export const uiExceptions = {
    'arrow-up-left-straight': 'arrow-up-left',
    'arrow-up-right-straight': 'arrow-up-right',
    share_ios: 'share-ios',
    OV: 'ov',
};
// export type UiExceptions = keyof typeof uiExceptions;
export function isUiException(type, variant) {
    return type === 'ui' && Object.keys(uiExceptions).includes(variant);
}
